import React, { useState } from 'react';
import { Button } from "../button/index.js";
import { Checkbox } from "../checkbox/Checkbox.js";
import { Tooltip } from "../tooltip/Tooltip.js";
import styles from "./PopConfirm.module.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const PopConfirm = ({
  title,
  content,
  iconRef,
  open,
  type = 'info',
  onConfirm,
  onCancel,
  onRememberMe,
  children
}) => {
  const [rememberMe, setRememberMe] = useState(false);
  return /*#__PURE__*/_jsx(Tooltip, {
    className: styles.tooltipPadding,
    title: title,
    content: /*#__PURE__*/_jsxs("div", {
      className: styles.content,
      children: [content, /*#__PURE__*/_jsxs("div", {
        className: styles.controls,
        children: [onRememberMe && /*#__PURE__*/_jsx(Checkbox, {
          classNames: styles.checkboxAlign,
          checked: rememberMe,
          onChange: e => {
            setRememberMe(e.target.checked);
            onRememberMe(e);
          },
          children: "Nicht mehr anzeigen"
        }), /*#__PURE__*/_jsxs("div", {
          className: styles.buttonGroup,
          children: [/*#__PURE__*/_jsx(Button, {
            variant: "outlined",
            onClick: onCancel,
            small: true,
            children: "Abbrechen"
          }), /*#__PURE__*/_jsx(Button, {
            onClick: onConfirm,
            small: true,
            children: "Ok"
          })]
        })]
      })]
    }),
    type: type,
    interactive: true,
    open: open,
    iconRef: iconRef,
    autoWidth: true,
    children: children
  });
};